import React from 'react';
import logo from './react.svg';
import './Home.css';

class Home extends React.Component {

  // componentWillReceiveProps() {
  //   const asuncF = async () => {
  //     glipWallet = await getGlipWallet();
  //     }
  //     asuncF();
  // }
  

  render() {
    return (
      <div className="Home">
        <div className="Home-header">
          <img src={logo} className="Home-logo" alt="logo" />
       
          {/* <div id="glip-wallet"></div> */}
        </div>        
      </div>
    );
  }
}

export default Home;
